// Centralised SEO constants - update REACT_APP_BASE_URL in .env to change across all pages
export const BASE_URL = process.env.REACT_APP_BASE_URL;
export const OG_IMAGE = 'https://customer-assets.emergentagent.com/job_precision-ops-4/artifacts/min5jub8_Gemini_Generated_Image_5zsofr5zsofr5zso%20%282%29.png';
